import { Box, Flex, HStack, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import { ArrowRight } from "@phosphor-icons/react";
import { asHTML } from "@prismicio/client";
import { resolvePrismicLink } from "utils/prismicLinks";
import CalloutBox from "./CalloutBox";
import { richTextSx } from "./richTextStyles";

// Colors match the website's Colums slice (antaia-website src/slices/Colums)
const GREEN = "#5A8A1A";

const COLUMN_COUNT_BY_LAYOUT = {
  "Single column": 1,
  "1 x 2": 2,
  "1 x 3": 3,
  "2 x 2": 2,
  "2 x 3": 3,
};

export default function ColumsSlice({ slice, onNavigate }) {
  const { heading, sub_heading, intro_text, column, column_layout, call_out } = slice.primary;
  const columnCount = COLUMN_COUNT_BY_LAYOUT[column_layout] || 2;

  return (
    <VStack align="stretch" gap={6}>
      {(heading || sub_heading || intro_text) && (
        <VStack align="center" textAlign="center" gap={2} maxW="640px" mx="auto">
          {heading && (
            <Text fontSize="24px" fontWeight="700" color="#0E3137">
              {heading}
            </Text>
          )}
          {sub_heading && (
            <Text fontSize="body.l" color={GREEN} fontWeight="600">
              {sub_heading}
            </Text>
          )}
          {intro_text && (
            <Text fontSize="body.m" color="gray.600">
              {intro_text}
            </Text>
          )}
        </VStack>
      )}

      {column?.length > 0 && (
        <SimpleGrid columns={{ base: 1, md: columnCount }} gap={6}>
          {column.map((item, index) => {
            const resolved = resolvePrismicLink(item.link_button);
            return (
              <Box
                key={index}
                bg="gray.50"
                borderRadius="lg"
                p={{ base: 5, md: 6 }}
                borderWidth="1px"
                borderColor="gray.200"
              >
                <VStack align="start" gap={2}>
                  {item.header && (
                    <Text
                      fontWeight="700"
                      fontSize="body.m"
                      textTransform="uppercase"
                      letterSpacing="wide"
                      color="#0E3137"
                    >
                      {item.header}
                    </Text>
                  )}
                  {item.sub_heading && (
                    <Text fontSize="body.m" color={GREEN} fontWeight="600">
                      {item.sub_heading}
                    </Text>
                  )}
                  {item.body?.length > 0 && (
                    <Box sx={richTextSx} dangerouslySetInnerHTML={{ __html: asHTML(item.body) }} />
                  )}
                  {resolved && (
                    <Flex
                      as={resolved.kind === "external" ? "a" : "div"}
                      href={resolved.kind === "external" ? resolved.url : undefined}
                      target={resolved.kind === "external" ? "_blank" : undefined}
                      rel={resolved.kind === "external" ? "noopener noreferrer" : undefined}
                      onClick={resolved.kind === "internal" ? () => onNavigate(resolved.uid) : undefined}
                      cursor="pointer"
                      align="center"
                      gap={1}
                      color={GREEN}
                      fontWeight="600"
                    >
                      <HStack gap={1}>
                        <Text color={GREEN} fontWeight="600">
                          {item.link_button.text || "Learn more"}
                        </Text>
                        <ArrowRight />
                      </HStack>
                    </Flex>
                  )}
                </VStack>
              </Box>
            );
          })}
        </SimpleGrid>
      )}

      <CalloutBox callOut={call_out?.[0]} isRichText />
    </VStack>
  );
}
